import React, { useEffect, useState } from "react";
import PropTypes    from "prop-types";
import Flux         from "../../../flux/Flux";
import TileGrid     from '../../TileGrid/TileGrid';
import LogoLoader   from '../../Loader/LogoLoader';
import Translations from "../../../utils/Translations";
import ReloadHelper from "../../../utils/ReloadHelper";

const ACTOR_COLLECTIONS = {
    [Flux.Constants.ActorId.LEXY_ROXX]:    {collectionName: 'lexy_girls'},
    [Flux.Constants.ActorId.LENI_FETISCH]: {collectionName: 'leni_girls'},
    [Flux.Constants.ActorId.LIAENGEL]:     {collectionName: 'lia_girls'},
    [Flux.Constants.ActorId.LANA_GREY]:    {collectionName: 'lana_girls'},
    [Flux.Constants.ActorId.LUCY_CAT]:     {collectionName: 'lucy_girls',firstModels: 20},
}

const ActorProfileTopCams = (props) => {

    const {actorId, isMobile } = props;

    const [topCams, setTopCams] = useState([]);

    useEffect(() => {

        loadTopCams();

        Flux.Actor.addActorTopCamsChangeListener(onTopCamsChange);

        return () => {
            Flux.Actor.removeActorTopCamsChangeListener(onTopCamsChange);
        }

    }, []);

    const loadTopCams = () => {
        const defaultArgs = {
            hiddenCategories: true,
            firstModels:      100,
        }

        const actorConfig = ACTOR_COLLECTIONS[actorId];

        if(!actorConfig) return;

        const args = {
            ...defaultArgs,
            collectionNames: [actorConfig.collectionName],
            firstModels:     actorConfig.firstModels || defaultArgs.firstModels,
        }
        const collectionName = args.collectionNames[0];
        const topCams        = Flux.Actor.getActorTopCams(collectionName);

        topCams ? setTopCams(topCams) : Flux.Actor.loadActorTopCams(args);
    };

    const onTopCamsChange = (collectionName) => {
        const actorTopCams = Flux.Actor.getActorTopCams(collectionName);
        if (actorTopCams) {
            const topModels = addSpecialHandling(actorTopCams);
            setTopCams(topModels);
        }
    };

    const addSpecialHandling = (models) => {
        if (actorId === Flux.Constants.ActorId.LUCY_CAT) {
            const lana = [...topCams].find(model => model.id === Flux.Constants.ActorId.LANA_GREY);
            if (lana) {
                models = models.filter(model => model.id !== Flux.Constants.ActorId.LANA_GREY);
                models.unshift(lana);
            }
        }
        return models;
    };

    const getTiles = (model, position, useBigUrl = false) => {
        return {
            actorId:            model.id,
            actorAge:           model.profile.age,
            actorName:          model.name,
            actorPosition:      position,
            targetUrl:          model.linkVX,
            previewPictureUrls: [
                [
                    {
                        format:     useBigUrl ? "w640" : "w320",
                        height:     model.avatar.height,
                        id:         model.avatar.id,
                        isPortrait: false,
                        src:        useBigUrl ? model.avatar.bigUrl : model.avatar.url,
                        width:      model.avatar.width,
                    },
                ],
            ],
            type:               "ACTOR_TOP100_GRID_TILE",
            plateType:          "ACTOR_TOP100_PLATE",
            isOnline:           model.online
        };
    };

    const getTop3 = () => {
		const top3 = topCams.slice(0, 3);
		return {
			cols:         isMobile ? 1 : 3,
			initialTiles: [
				...top3.map((model, index) => getTiles(model, index + 1, true))
			],
			searchTags:   [],
			showButton:   true,
			showMediaPin: false,
			usePjax:      !isMobile,
		};
	};

    const getTopOther = () => {
		const top3 = topCams.slice(3);
		return {
			cols:         isMobile ? 1 : 4,
			initialTiles: [
				...top3.map((model, index) => getTiles(model, index + 4, isMobile))
			],
			searchTags:   [],
			showButton:   true,
			showMediaPin: false,
			usePjax:      !isMobile,
		};
	};

    const getTitle = () => {
		let title = "Top Cams";

		switch (actorId) {
			case Flux.Constants.ActorId.LEXY_ROXX:
				title = 'Lexys Girls';
				break;
			case Flux.Constants.ActorId.LENI_FETISCH:
				title = 'Lenis Girls';
				break;
			case Flux.Constants.ActorId.LUCY_CAT:
				title = 'Lucys Girls';
				break;
			case Flux.Constants.ActorId.LANA_GREY:
				title = 'Lanas Girls';
				break;
			case Flux.Constants.ActorId.LIAENGEL:
				title = 'Lias Girls';
				break;
		}

		return title;
	};

    let content = <LogoLoader pulse className={isMobile ? "" : "-absolute"} />;
    if(topCams.length > 0) {
        content = (
            <>
                <section className="container-block -no-margin-bottom">
					<div className="context-box--actor-profile clearfix">
						<h3
                            className="context-box__title --white h-left"
                            dangerouslySetInnerHTML={{__html: getTitle()}}
                        />
					</div>
				</section>

				<section className="container-block">
					<h2 className="context-box__rankingtitle h-text-align-center">
						<span className="h-color-fg-hint">{Translations.get('Ranking')}</span> 1 - 3</h2>
					<TileGrid
						gridConfig		= {getTop3()}
						gridMode		= "TILEGRID_MODE_GRID"
						isMobile		= {isMobile}
						guestIsLoggedIn = {Flux.Guest.isLoggedIn()}
					/>
				</section>
				{topCams.length > 3 && <section className="container-block">
					<h2 className="context-box__rankingtitle h-text-align-center">
						<span className="h-color-fg-hint">
                            {Translations.get('Ranking')}
                        </span> 4 - {topCams.length}
                    </h2>
					<TileGrid
						gridConfig		= {getTopOther()}
						gridMode		= "TILEGRID_MODE_GRID"
						isMobile		= {isMobile}
						guestIsLoggedIn = {Flux.Guest.isLoggedIn()}
					/>
				</section>}
            </>
        );
    };

    return <div className="h-min-height-100vh">{content}</div>;
};

ActorProfileTopCams.propTypes = {
	actorId:  PropTypes.number,
	isMobile: PropTypes.bool
};

export default ActorProfileTopCams;
